import { ReactNode } from 'react'
import {
	Button,
	Dialog,
	Heading,
	Modal,
	ModalOverlay,
	ModalRenderProps,
} from 'react-aria-components'

const modalStyles = {
	base: 'absolute right-0 top-0 h-full bg-white border-l border-gray-200 shadow-xl animate-in fade-in slide-in-from-right-1 ease-out duration-200',
	isEntering: 'animate-in slide-in-from-right ease-out duration-200',
	isExiting: 'animate-out slide-out-to-right ease-in duration-100',
}

const overlayStyles = {
	base: 'fixed inset-0 bg-gray-400/50',
	isEntering: 'animate-in fade-in duration-200 ease-out',
	isExiting: 'bg-transparent pointer-events-none',
}

const className =
	(styles: typeof modalStyles) =>
	({ isEntering, isExiting }: ModalRenderProps) =>
		`${styles.base} ${isEntering ? styles.isEntering : ''} ${isExiting ? styles.isExiting : ''}`

export function Sidepanel({
	heading,
	children,
}: {
	heading: ReactNode
	children: ReactNode | ((renderProps: { close: VoidFunction }) => ReactNode)
}) {
	return (
		<ModalOverlay className={className(overlayStyles)} isDismissable>
			<Modal className={className(modalStyles)}>
				<Dialog className="h-full min-w-[360px] flex flex-col outline-0">
					{({ close }) => (
						<>
							<Heading
								slot="title"
								className="bg-gray-50 border-b border-gray-200 p-4 text-lg flex-none"
							>
								{heading}
							</Heading>
							<Button
								onPress={close}
								className="absolute top-2 right-[100%] rounded-l-lg bg-slate-900 text-xs text-slate-50 p-3 leading-none"
								aria-label="Zavřít"
							>
								╳
							</Button>
							{typeof children === 'function' ? children({ close }) : children}
						</>
					)}
				</Dialog>
			</Modal>
		</ModalOverlay>
	)
}

export function SidepanelContent({
	children,
	className,
}: {
	children: ReactNode
	className?: string
}) {
	return <div className={`flex-1 overflow-auto p-4 ${className ?? ''}`}>{children}</div>
}

export function SidepanelFooter({ children }: { children: ReactNode }) {
	return (
		<div className="bg-gray-50 border-t border-gray-200 p-4 flex-none flex justify-between items-center">
			{children}
		</div>
	)
}
